module.exports = __webpack_public_path__ + "img/sbp.5b57434a.svg";